import { ModuleNode } from '../types';
import { hideRMPlatformCost } from '../../../service/config';
export const finopsModule: ModuleNode = {
	key: 'finops',
	title: 'Finops',
	submodules: [
		{
			key: 'resourceMapping',
			title: 'Resource Mapping',
			route: '/dashboard/financeOpsLanding',
			pages: [
				{
					key: 'programs',
					title: 'Programs',
					route: '/finops/resourcemapping/programs',
					items: [{ key: 'prgms', label: 'Programs', tags: ['add program'] }]
				},
				{
					key: 'search-Allocate',
					title: 'Search & Allocate',
					route: '/finops/resourcemapping/search',
					items: [
						{
							key: 'resources',
							label: 'Resources',
							tags: ['resources', 'allocation', 'environment', 'pepwise', 'subscription', 'Query Preferences']
						}
					]
				},
			]
		},
		...(hideRMPlatformCost ? [] : [{
			key: 'platformCost',
			title: 'Platform Cost',
			route: '/dashboard/financeOpsLanding',
			pages: [
				{
					key: 'platform-cost',
					title: 'Platform Cost',
					route: '/platformCostObs/dashboard',
					items: [
						{
							key: 'platform-cost-dashboard',
							label: 'Platform Cost',
							tags: ['PBNA', 'LATAM', 'PFNA', 'CGF', 'AMESA', 'APAC']
						}
					]
				}
			]
		}])
	]
};
